import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import {Loading} from '../Loading';
import * as PropTypes from 'prop-types';

let identifier = 0;
export function RoleSelect({ role, loading, onChange }) {
    const [id, setID] = React.useState();
    React.useEffect(() => {
        setID(identifier++);
    }, []);

    return (
        <Loading loading={loading}>
            <FormControl style={{ minWidth: 195}} variant="outlined">
                <InputLabel htmlFor={`role-${id}`}>Role</InputLabel>
                <Select disabled={loading}
                    inputProps={{
                        name: 'role',
                        id: `role-${id}`
                    }}
                    labelWidth={35}
                    onChange={async ({ target }) => onChange(target.value)}
                    style={{ maxHeight: '2.5em' }}
                    value={role}>
                    <MenuItem value={'ADMIN'}>Admin</MenuItem>
                    <MenuItem value={'ASSIGN'}>Assignment</MenuItem>
                    <MenuItem value={'VIEW'}>View Only</MenuItem>
                </Select>
            </FormControl>
        </Loading>
    );
}
RoleSelect.propTypes = {
    role: PropTypes.string,
    loading: PropTypes.symbol,
    onChange: PropTypes.object
}
